import { render } from "./logout.vue?vue&type=template&id=5e0fe56a&scoped=true&ts=true"
import script from "./logout.vue?vue&type=script&lang=ts"
export * from "./logout.vue?vue&type=script&lang=ts"

import "./logout.vue?vue&type=style&index=0&id=5e0fe56a&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0fe56a"]])

export default __exports__